export const CART_ITEM_ACTION_TYPES = {
  LOAD_CARTS_SUCCESS: 'LOAD_CARTS_SUCCESS',
  CREATE_CART_ITEM_OPTIMISTIC: 'CREATE_CART_ITEM_OPTIMISTIC',
  UPDATE_CART_ITEM_OPTIMISTIC: 'UPDATE_CART_ITEM_OPTIMISTIC',
  REMOVE_CART_ITEM_OPTIMISTIC: 'REMOVE_CART_ITEM_OPTIMISTIC'
};
